'use strict';

var IPreferencesManager = require('./IPreferencesManager');

var CookiePreferencesManager = function() {
    this.initialize();
};

jQuery.extend(jQuery.extend(CookiePreferencesManager.prototype, IPreferencesManager), {
    /*
        Public Methods
    */
    initialize: function(){}, // no initialization really necessary

    /*
        Implementation: IPreferencesManager
    */
    setPreference: function(name, value){
        var expDate = new Date();
        expDate.setTime(expDate.getTime() + 1000 * 60 * 60 * 24 * 365);        // set expiration for a year from now
        document.cookie = name + '=' + escape(value) + '; expires=' + expDate.toGMTString() + '; path=/; ';
    },

    getPreference: function(name){
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) ===' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },

    deletePreference: function(name){
        var expDate = new Date();
        expDate.setTime(-1);
        document.cookie = name + '=; expires=' + expDate.toGMTString() + '; path=/; ';
    }
});

module.exports = CookiePreferencesManager;


//////////////////
// WEBPACK FOOTER
// ./mits/Storage/CookiePreferencesManager.js
// module id = 25
// module chunks = 0